import React from "react";
import { Spinner } from "reactstrap";
import useConfiguration from "./hooks/useConfiguration";
import VeladasGraph from "./VeladasGraph";

const VeladasGraphWrapper = () => {
  const { horarioVelada, isLoadingConfiguration } = useConfiguration();

  if (isLoadingConfiguration)
    return (
      <div className="page-content">
        <div className="text-center py-4">
          <Spinner />
          <p>Cargando configuración</p>
        </div>
      </div>
    );

  return (
    <React.Fragment>
      <VeladasGraph horarioVelada={horarioVelada} />
    </React.Fragment>
  );
};

export default VeladasGraphWrapper;
